export default "__VITE_ASSET__BWoU1Oo0__"